import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { router } from './router';
import { Providers } from './providers';
import { getDirection, type Locale } from './i18n/config';

export function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const locale = i18n.language as Locale;
    const direction = getDirection(locale);
    document.documentElement.lang = locale;
    document.documentElement.dir = direction;
  }, [i18n.language]);

  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
